(() => {
  if (customElements.get("information-table-2")) {
    return;
  }

  class InformationTable2 extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        wrapper: "[data-wrapper]",
        slider: "[data-slider]",
        pagination: "[data-pagination]",
        tableParent: ".information-table-2",
        nextArrow: ".information-table-2__slider-next"
      };
      this.slider = this.querySelector(this.selectors.slider);
      this.options = {
        pagination: {
          el: this.closest(this.selectors.wrapper).querySelector(
            this.selectors.pagination
          ),
          type: "bullets",
          clickable: true,
        },
        navigation: {
          nextEl: this.closest(this.selectors.tableParent).querySelector(
            this.selectors.nextArrow
          )
        },
        spaceBetween: 16,
        slidesPerView: 1,
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 5,
          },
          1200: {
            slidesPerView: 4,
          },
        },
      };
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.slider) return;
      this.slider = new Swiper(this.slider, this.options);
    }
  }

  customElements.define("information-table-2", InformationTable2);
})();
